import {

  GET_ACCOUNT_PERMISSIONS_REQUEST ,
  GET_ACCOUNT_PERMISSIONS_FAILURE,
  GET_ACCOUNT_PERMISSIONS_SUCCESS,
  POST_ACCOUNT_PERMISSIONS_SUCCESS

} from './permissionsActions';

const initialState = {
  pending: false,
  hasError: false,
  error: null,
  permissionedAccounts: {
    allIds: [],
    byId: {}
  } 
};

const permissionsReducer = (state = { ...initialState }, action) => {
  switch(action.type) {

    ////////////////////////
    // Get Handlers
    ////////////////////////
    case GET_ACCOUNT_PERMISSIONS_REQUEST: {
      return { ...state, pending: action.isFetching };
    }
    case GET_ACCOUNT_PERMISSIONS_SUCCESS: {
      const byId = {};
      const allIds = []
      action.payload.forEach(entity => {
        byId[entity.id] = entity;
        allIds.push(entity.id);
      });
      return {
        ...state,
        pending: false,
        hasError: false,
        permissionedAccounts: {
          ...state.permissionedAccounts,
          byId,
          allIds
        }
      };
    }
    case  GET_ACCOUNT_PERMISSIONS_FAILURE: {
      return {
        ...state,
        pending: false,
        hasError: true,
        error: action.error
      };
    }

    case POST_ACCOUNT_PERMISSIONS_SUCCESS: {
      const { payload } = action;
      const byId = {...state.permissionedAccounts.byId };
      const allIds = [...state.permissionedAccounts.allIds];
      byId[payload.id] = payload;
      allIds.push(payload.id);
      return {
        ...state,
        pending: false,
        hasError: false,
        permissionedAccounts: {
          ...state.permissionedAccounts,
          byId,
          allIds
        }
      };
    }

    default: {
      return state;
    }
  }
}


export default permissionsReducer;
